// TODO: Move this to @/modules/people/utils/pay-rate/pay-rule.ts as it's used by stores & components across people module
import { PayRule } from '@/modules/people/types/employment';
import { PayRuleOverride } from '@/modules/people/types/people';

export const enum PayRuleValueFields {
  HourlyRate = 'HourlyRate',
  UnitValue = 'UnitValue',
  MulValue = 'MultiplierValue',
}

export function getPayRuleValueFieldName(payRule: PayRule): PayRuleValueFields {
  if (payRule.IsMultiplier) {
    return PayRuleValueFields.MulValue;
  } else if (payRule.UnitValue !== null) {
    return PayRuleValueFields.UnitValue;
  } else {
    return PayRuleValueFields.HourlyRate;
  }
}

export type PayRuleOverrideMap = Record<number, PayRuleOverride['value']>;

export type PayRuleOverrideMapByAgreement = Record<number, PayRuleOverrideMap>;

export type AreaBasePayRuleOverrideMapByAreaId = Record<
  number,
  PayRuleOverrideMap
>;
export function createPayRuleOverridesMap(
  payRuleOverrides: Array<PayRuleOverride>
): PayRuleOverrideMap {
  return payRuleOverrides.reduce<PayRuleOverrideMap>(
    (current, payRuleOverride) => {
      current[payRuleOverride.payRuleId] = payRuleOverride.value;
      return current;
    },
    {}
  );
}
